export enum LayoutStatus {
  DRAFT = "DRAFT",
  VALIDATED = "VALIDATED",
}
